import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "knockout-container" }
const _hoisted_2 = { class: "py-6 px-8 d-flex justify-space-between" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = {
  key: 1,
  class: "ml-3"
}

import {ApiMap} from "@/api/type";
import {reactive, ref, watch} from "vue";
import {useApi} from "@/api/handler";
import {proposal} from "@/api";
import DynamicForm from "@/components/DynamicForm.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BuzzQuiz',
  props: {
    data: {}
  },
  emits: ['update'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const GameStatus = ref<ApiMap['/game/status/:id']['resp'] | null>(null)
const teamList = ref<ApiMap['/proposal/rank/third']['resp'] | null>(null)
const rankColors = ['amber darken-2', 'blue-grey lighten-1', 'deep-orange lighten-1']
const headers = [
  { title: '排名', value: 'rank'},
  { title: '组号', value: 'teamId'},
  { title: '分数', value: 'score' },
  { title: '组长', value: 'leaderName' },
  { title: '操作', value: 'action', align: 'center' },
]
const showOverlay = ref<boolean>(false)
const tempIndex = ref<number>(0)
const scoreMap = reactive(new Map<number, ApiMap['/proposal/buzzed']['req']>())
const pageSize = ref<number>(100)

function handleChange(index: number) {
  tempIndex.value = index
  console.log(index)
  if (!scoreMap.has(index)) scoreMap.set(index, {
    gameId: GameStatus.value!.id,
    teamId: teamList.value![index].teamId ,
    score: 0,
    comment: ""
  })
  console.log(scoreMap.get(index))
  showOverlay.value = true
}

function handleTeamList () {
  if (!teamList.value) return
  return teamList.value.map(item => ({
    rank: item.rank,
    teamId: `第 ${item.teamId} 组`,
    leaderName: item.leaderName,
    score: `${item.score} 分`,
    action: true
  }))
}

const useThirdRank = () => {
  if (!GameStatus.value) return
  useApi({
    api: proposal.ThirdRank(GameStatus.value.id),
    onSuccess: resp => {
      teamList.value = resp.data as ApiMap['/proposal/rank/third']['resp']
    }
  })
}

const useSubmitBuzz = () => {
  useApi({
    api: proposal.SubmitBuzz(GameStatus.value!.id),
    onSuccess: () => {
      emits('update')
    },
    tip: '上传成功'
  })
}

const useBuzzSetScore = (data: ApiMap['/proposal/buzzed']['req']) => {
  data.score = +data.score
  useApi({
    api: proposal.BuzzSetScore(data),
    onSuccess: () => {
      showOverlay.value = false
      useThirdRank()
    },
    tip: '更改成功'
  })
}

watch(() => props.data, () => {
  GameStatus.value = props.data ?? null
  useThirdRank()
}, {immediate: true})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-h5 text-indigo-lighten-2" }, "第三轮提案 抢答赛", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_btn, {
            class: "ml-4",
            rounded: "",
            color: "primary",
            variant: "outlined",
            onClick: useSubmitBuzz
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("结束抢答赛")
            ])),
            _: 1,
            __: [3]
          })
        ])
      ]),
      _createVNode(_component_v_card, {
        class: "mx-4",
        style: {"overflow-y":"auto"}
      }, {
        default: _withCtx(() => [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "py-4 d-flex text-h6 justify-center bg-indigo-lighten-2" }, "当前抢答赛排名", -1)),
          _createVNode(_component_v_data_table, {
            items: handleTeamList() ?? [],
            height: "550",
            headers: headers,
            "item-value": "teamId",
            "hide-default-footer": "",
            "no-data-text": "请先传入学习通数据",
            class: "pa-4",
            "items-per-page": pageSize.value,
            "onUpdate:itemsPerPage": _cache[0] || (_cache[0] = ($event: any) => ((pageSize).value = $event))
          }, {
            "item.rank": _withCtx(({ index }) => [
              (index < 3)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 0,
                    color: rankColors[index],
                    "text-color": "white",
                    density: "compact",
                    small: "",
                    label: "",
                    class: "font-weight-bold"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 第 " + _toDisplayString(index + 1) + " 名 ", 1)
                    ]),
                    _: 2
                  }, 1032, ["color"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, "第 " + _toDisplayString(index + 1) + " 名", 1))
            ]),
            "item.action": _withCtx(({ index }) => [
              _createVNode(_component_v_btn, {
                variant: "text",
                "prepend-icon": "mdi-pencil-plus",
                onClick: ($event: any) => (handleChange(index))
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("更改")
                ])),
                _: 2,
                __: [5]
              }, 1032, ["onClick"])
            ]),
            _: 1
          }, 8, ["items", "items-per-page"])
        ]),
        _: 1,
        __: [6]
      })
    ]),
    _createVNode(_component_v_overlay, {
      modelValue: showOverlay.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showOverlay).value = $event)),
      class: "align-center justify-center"
    }, {
      default: _withCtx(() => [
        (scoreMap.get(tempIndex.value))
          ? (_openBlock(), _createBlock(DynamicForm, {
              key: 0,
              model: scoreMap.get(tempIndex.value),
              title: "请输入积分变更数据",
              headers: ['', '', '分数变更', '评论'],
              "excluded-keys": [ 'gameId', 'teamId'],
              onSubmit: useBuzzSetScore,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (showOverlay.value = false))
            }, null, 8, ["model"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})